export default __webpack_public_path__ + "./image/b12536fd7040a39c48e3b1e15617a3f3.png";